(function(){
    angular
        .module('appback')
        .directive('ngCoprologico054tincion', coprologico054tincion);

        coprologico054tincion.$inject = ['ResultadosService','$timeout'];
        function coprologico054tincion(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=coprologico054tincion.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {

			            if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { microorganismos : [{}] }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { microorganismos : [{}] }};
				            }
				        }
		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                     }

	                    scope.optionsMicroorganismos = { 
		            		ajax: {
		                        url: "/backend/resultadopeticion/select2microorganismo",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};
		            	scope.optionsAtributos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2atributos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'valoresatt'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}
			        });
		        }
          }
      }
})();